import { useQuery } from '@tanstack/react-query';
import { getMedicalCodeClient } from '@/lib/api-clients';
import type { MedicalCodeType } from '@vagusx/clients';

/**
 * Hook to search medical codes with debounced query.
 * Returns results for autocomplete — only fires when query has 2+ characters.
 */
export function useMedicalCodeSearch(type: MedicalCodeType, query: string, limit: number = 20) {
  const trimmed = query.trim();
  return useQuery({
    queryKey: ['medicalCodes', type, trimmed, limit],
    queryFn: () => getMedicalCodeClient().search(type, trimmed, limit),
    enabled: trimmed.length >= 2,
    staleTime: 5 * 60 * 1000, // 5 min — codes don't change
  });
}
